import s from './style.module.scss';
import { Tooltip } from 'antd';
import { formatFileSize } from '@/utils';
import { Display } from '@/components/Display/Display';
import { fileStatusMap } from '@/utils/Page/constant';
import { fileTypeMap } from '@/utils/Page/constant';
import { parseStatusDic, fileStatusDic } from '@/utils/Page/constant';
// import { parseStatusMap } from '@/utils/Page/constant';
const FileInfo = ({ file }) => {
    return (
        <div className={s['file-info-wrap']}>
            <Display show={true}>
                <div className={s['file-info']}>
                    <Display show={file.type !== fileTypeMap.link}>
                        <Tooltip title={file.name}>
                            <div
                                data-text={file.name}
                                className={`${s['file-name']} ${
                                    file.parse_status === parseStatusDic.ing || file.parse_status === parseStatusDic.unstart ? 'loading-text' : ''
                                }`}
                            >
                                {file.name}
                            </div>
                        </Tooltip>
                    </Display>
                    <Display show={file.type === fileTypeMap.link}>
                        <Tooltip title={file?.title || file.name}>
                            <div
                                data-text={file?.title || file.name}
                                className={`${s['file-name']} ${
                                    file.parse_status === parseStatusDic.ing || file.parse_status === parseStatusDic.unstart ? 'loading-text' : ''
                                }`}
                            >
                                {file?.title || file.name}
                            </div>
                        </Tooltip>
                    </Display>
                </div>
                <div className={s['file-status']}>
                    {/* 上传中和上传失败 */}
                    <Display show={file.status !== fileStatusDic.success}>
                        <div className={`${s['status']}`} data-status={file.status}>
                            {fileStatusMap[file.status]}
                        </div>
                    </Display>
                    {/* 上传成功 */}
                    <Display show={file.status === fileStatusDic.success}>
                        <Display show={file.parse_status === parseStatusDic.ing || file.parse_status === parseStatusDic.unstart}>
                            <div className={`${s['status']}`}>{file.type === fileTypeMap.link ? '解析中' : `上传中`}</div>
                        </Display>
                        <Display show={file.parse_status === parseStatusDic.fail}>
                            <div className={`${s['status']}`} data-status={0}>
                                {file.type === fileTypeMap.link ? '解析失败' : `上传失败`}
                            </div>
                        </Display>
                        <Display show={file.parse_status === parseStatusDic.success}>
                            <Display show={file.type !== fileTypeMap.link}>
                                <div className={s['file-type']}>{file?.ext_type?.toUpperCase()}</div>
                                <div className={s['file-size']}>{formatFileSize(file?.size)}</div>
                            </Display>
                            <Display show={file.type === fileTypeMap.link}>
                                <div className={s['file-type']}> {file?.base_url || '链接'} </div>
                            </Display>
                        </Display>
                    </Display>
                </div>
            </Display>
            {/* <Display show={file.type === fileTypeMap.link}>
                <div className={s['file-info']}>
                    <Tooltip title={file.name}>
                        <div className={s['file-name']}>{file?.title || file.name}</div>
                    </Tooltip>
                </div>
                <div className={s['file-status']}>
                    <div className={s['file-type']}> {file?.base_url || '链接'} </div>
                </div>
            </Display> */}
        </div>
    );
};

export default FileInfo;
